// Centralized furniture categories list
// Update this list as taxonomy evolves
export const FURNITURE_CATEGORIES = [
  // Living Room
  'sofas',
  'sectionals',
  'loveseats',
  'recliners',
  'accent chairs',
  'chaise lounges',
  'sofa beds',
  'futons',
  'ottomans',
  'benches',
  'coffee tables',
  'end tables',
  'console tables',
  'sofa tables',
  'tv stands',
  'media consoles',
  'bookcases',
  'shelving',
  'curio cabinets',
  // Bedroom
  'beds',
  'platform beds',
  'upholstered beds',
  'headboards',
  'mattresses',
  'nightstands',
  'dressers',
  'chests',
  'armoires',
  'vanities',
  'bunk beds',
  'daybeds',
  'cribs',
  // Dining
  'dining tables',
  'dining chairs',
  'bar stools',
  'counter stools',
  'benches (dining)',
  'buffets',
  'sideboards',
  'china cabinets',
  'kitchen islands',
  'bar carts',
  // Office
  'desks',
  'office chairs',
  'bookcases (office)',
  'filing cabinets',
  'hutches',
  // Outdoor
  'patio sets',
  'outdoor sofas',
  'outdoor chairs',
  'outdoor tables',
  'outdoor loungers',
  // Decor & Other
  'rugs',
  'lighting',
  'mirrors',
  'storage',
  'room dividers',
  'entryway furniture',
  'accent cabinets',
  'shoe racks',
  'coat racks',
  // General fallback
  'other'
];

export default FURNITURE_CATEGORIES;
